export default __webpack_public_path__ + "static/media/ukpc18.1350fbb8.png";